import { create } from 'zustand';
import type { TimesheetSubmission } from '../types/timesheet-approval.types';

export interface ApprovalState {
  // Current user's active period submission status
  mySubmission: TimesheetSubmission | null;
  setMySubmission: (ts: TimesheetSubmission | null) => void;

  // Pending approvals list
  pendingTimesheets: TimesheetSubmission[];
  setPendingTimesheets: (items: TimesheetSubmission[]) => void;
  pendingLoading: boolean;
  setPendingLoading: (loading: boolean) => void;

  // Detail panel
  selectedTimesheetId: string | null;
  setSelectedTimesheetId: (id: string | null) => void;
  timesheetDetail: TimesheetSubmission | null;
  setTimesheetDetail: (detail: TimesheetSubmission | null) => void;

  // History
  historyTimesheets: TimesheetSubmission[];
  setHistoryTimesheets: (items: TimesheetSubmission[]) => void;
  historyTotal: number;
  setHistoryTotal: (total: number) => void;
  historyPage: number;
  setHistoryPage: (page: number) => void;
  historyPageSize: number;

  // Pending count (for badge in sidebar)
  pendingCount: number;
  setPendingCount: (count: number) => void;

  // Dialogs
  rejectDialogOpen: boolean;
  setRejectDialogOpen: (open: boolean) => void;
  reopenDialogOpen: boolean;
  setReopenDialogOpen: (open: boolean) => void;
  statusHistoryDialogOpen: boolean;
  setStatusHistoryDialogOpen: (open: boolean) => void;
  submitDialogOpen: boolean;
  setSubmitDialogOpen: (open: boolean) => void;
}

export const useApprovalStore = create<ApprovalState>((set) => ({
  mySubmission: null,
  setMySubmission: (mySubmission) => set({ mySubmission }),

  pendingTimesheets: [],
  setPendingTimesheets: (pendingTimesheets) => set({ pendingTimesheets }),
  pendingLoading: false,
  setPendingLoading: (pendingLoading) => set({ pendingLoading }),

  selectedTimesheetId: null,
  setSelectedTimesheetId: (selectedTimesheetId) =>
    set({ selectedTimesheetId, timesheetDetail: null }),
  timesheetDetail: null,
  setTimesheetDetail: (timesheetDetail) => set({ timesheetDetail }),

  historyTimesheets: [],
  setHistoryTimesheets: (historyTimesheets) => set({ historyTimesheets }),
  historyTotal: 0,
  setHistoryTotal: (historyTotal) => set({ historyTotal }),
  historyPage: 1,
  setHistoryPage: (historyPage) => set({ historyPage }),
  historyPageSize: 50,

  pendingCount: 0,
  setPendingCount: (pendingCount) => set({ pendingCount }),

  rejectDialogOpen: false,
  setRejectDialogOpen: (rejectDialogOpen) => set({ rejectDialogOpen }),
  reopenDialogOpen: false,
  setReopenDialogOpen: (reopenDialogOpen) => set({ reopenDialogOpen }),
  statusHistoryDialogOpen: false,
  setStatusHistoryDialogOpen: (statusHistoryDialogOpen) =>
    set({ statusHistoryDialogOpen }),
  submitDialogOpen: false,
  setSubmitDialogOpen: (submitDialogOpen) => set({ submitDialogOpen }),
}));
